import header from "./immobilienverkauf-1.jpg";
import section1 from "./immobilienverkauf-2.jpg";
import section2 from "./immobilienverkauf-3.jpg";
import section3 from "./immobilienverkauf-4.jpg";
import section4 from "./immobilienverkauf-5.jpg";
import section5 from "./immobilienverkauf-6.jpg";
import section6 from "./immobilienverkauf-7.jpg";
import section7 from "./immobilienverkauf-8.webp";
import section8 from "./immobilienverkauf-9.jpg";
import section9 from "./immobilienverkauf-10.jpg";
import section10 from "./immobilienverkauf-11.jpg";
import section11 from "./immobilienverkauf-12.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
  section11,
};
